import { useNavigate } from 'react-router-dom';
import Silk from './Silk';

function Intro() {
  const navigate = useNavigate();

  const handleEnterPortal = () => {
    navigate('/login');
  };

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        background: '#000000',
        position: 'fixed',
        top: 0,
        left: 0,
        overflow: 'hidden'
      }}
    >
      <Silk
        speed={5}
        scale={1}
        color="#8052ff"
        noiseIntensity={1.5}
        rotation={0}
      />
      
      <div 
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          zIndex: 10,
          color: '#ffffff',
          maxWidth: '800px',
          padding: '0 20px'
        }}
      >
        <h1 
          style={{
            fontSize: '78px',
            fontWeight: '200',
            lineHeight: '0.9',
            letterSpacing: '-0.04em',
            marginBottom: '1.5rem',
            color: '#ffffff',
            fontFamily: "'Inter', 'Space Grotesk', system-ui, sans-serif"
          }}
        >
          Master the Syllabus. Own the Exam.
        </h1>
        
        <p 
          style={{
            fontSize: '18px',
            fontWeight: '400',
            lineHeight: '1.5',
            letterSpacing: '0.025px',
            marginBottom: '2.5rem',
            color: '#bdbdbd',
            fontFamily: "'Inter', 'Space Grotesk', system-ui, sans-serif"
          }}
        >
          A curated constellation of ISC/ICSE resources, past papers, and collective intelligence. Navigate the void.
        </p>
        
        <button
          onClick={handleEnterPortal}
          style={{
            padding: '14px 32px',
            background: '#8052ff',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: '600',
            letterSpacing: '0.05px',
            textTransform: 'uppercase',
            borderRadius: '24px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontFamily: "'Inter', 'Space Grotesk', system-ui, sans-serif"
          }}
        >
          ENTER PORTAL
        </button>
      </div>
    </div>
  );
}

export default Intro;
